import classNames from 'classnames'
import gsap from 'gsap'
import * as React from 'react'

import {makeEditable} from '@/common/utils'
import Link from '@/components/Link'
import MarqueeWrapper from '@/components/MarqueeWrapper'

const ScrollingTitle = ({backgroundColors, title, label, link, _editable}) => {
  const buttonRef = React.useRef()

  const onMouseMove = React.useCallback(({currentTarget, clientX, clientY}) => {
    const button = buttonRef.current
    if (button) {
      let {left, top} = currentTarget.getBoundingClientRect()
      const x = clientX - left
      const y = clientY - top
      const targetWidth = currentTarget.clientWidth
      const xPosition = Math.round(gsap.utils.mapRange(0, targetWidth, -1, 1, x) * 100) / 100
      gsap.set(button, {left: x, top: y, x: 0, y: 0, rotate: `${xPosition * 10}deg`})
    }
  }, [])

  return (
    <section
      {...makeEditable(_editable)}
      className={classNames('relative py-30', backgroundColors.previous)}
    >
      <div onMouseMove={onMouseMove} className='group relative'>
        <Link link={link}>
          <MarqueeWrapper reverseOnScrollUp={false} maxVelocity={0} className='p-4'>
            <span className='misc-scrolling-title px-4 text-violet-600'>{title}</span>
          </MarqueeWrapper>
          <div
            ref={buttonRef}
            className='pointer-events-none absolute top-0 left-0 hidden w-max translate-x-0 translate-y-0 rotate-0  group-hover:block'
          >
            <DoodleSymbol aria-hidden className='absolute -top-22 right-14' />
            <span className='misc-button-m button-m-bold absolute top-0 left-0 hidden  w-max -translate-x-1/2 -translate-y-full rounded-full bg-purple-900 px-8 py-4 text-white lg:block'>
              {label}
            </span>
          </div>
        </Link>
      </div>
    </section>
  )
}

const DoodleSymbol = (props) => (
  <svg
    width='59'
    height='45'
    viewBox='0 0 59 45'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.4418 33.6714C0.652867 33.1611 1.2377 32.9185 1.74806 33.1295L24.4595 42.5221C24.9699 42.7332 25.2125 43.318 25.0014 43.8284C24.7904 44.3388 24.2055 44.5814 23.6952 44.3703L0.983721 34.9777C0.47336 34.7666 0.230733 34.1818 0.4418 33.6714ZM15.8427 0.75585C16.2092 0.342733 16.8413 0.30498 17.2544 0.671521C18.2887 1.5892 19.5459 3.43812 20.8682 5.68265C22.2147 7.96824 23.6995 10.79 25.1785 13.7649C28.1374 19.7167 31.098 26.3317 32.9215 30.6086C33.1381 31.1167 32.9019 31.7041 32.3938 31.9207C31.8858 32.1373 31.2983 31.9011 31.0817 31.393C29.2688 27.141 26.3246 20.563 23.3876 14.6552C21.9185 11.7003 20.4575 8.92563 19.145 6.69783C17.8084 4.42897 16.6934 2.84752 15.927 2.16755C15.5139 1.801 15.4762 1.16897 15.8427 0.75585ZM50.1875 25.5138C50.0065 26.0356 50.2828 26.6053 50.8046 26.7863C51.3264 26.9673 51.8961 26.6911 52.0771 26.1693L58.5119 7.61908C58.6929 7.0973 58.4167 6.52758 57.8949 6.34658C57.3731 6.16559 56.8034 6.44184 56.6224 6.96362L50.1875 25.5138Z'
      fill='#7F6AFF'
    />
  </svg>
)

export default ScrollingTitle
